import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

import { lazy } from "react";

const DashboardLayout = lazy(() => import("../layouts/DashboardLayout"));

const Login = lazy(() => import("../pages/Login/Login"));
const LoginSocial = lazy(() => import("../pages/Login/LoginSocial"));
const ForgotPassword = lazy(() => import("../pages/Login/ForgotPassword"));
const LoginApple = lazy(() => import("../pages/Login/LoginApple"));

const SignUp = lazy(() => import("../pages/Registration/SignUp"));
const Register = lazy(() => import("../pages/Registration"));
const VerifyOtp = lazy(() => import("../pages/Registration/VerifyOtp"));
const Congratulation = lazy(() => import("../pages/Registration/Congratulation"));

const NewChat = lazy(() => import("../pages/Chat/NewChat"));
const Chat = lazy(() => import("../pages/Chat/Chat"));

const MyAccount = lazy(() => import("../pages/Profile"));
const Faqs = lazy(() => import("../pages/Faqs"));
const TermsConditions = lazy(() => import("../pages/TermsConditions"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const EULA = lazy(() => import("../pages/EULA"))
const CookiePolicy = lazy(() => import("../pages/CookiePolicy"))
const LegalDisclosure = lazy(() => import("../pages/LegalDisclosure"))
const AboutUs = lazy(() => import("../pages/AboutUs"))

const UpgradePlan = lazy(() => import("../pages/UpgradePlan"));
const ManagePlan = lazy(() => import("../pages/ManagePlan"));
const PaymentHistory = lazy(() => import("../pages/PaymentHistory"));

const Transaction = lazy(() => import("../pages/Transaction"));

const Quiz = lazy(() => import("../pages/Quiz"));
const Result = lazy(() => import("../pages/Quiz/Result"));


const ExploreQuikwise = lazy(() => import("../pages/ExploreQuikwise"));
const LandingPage = lazy(() => import("../pages/LandingPage"));
const OrderSummary = lazy(() => import("../pages/OrderSummary"));

const AppRoutes = () => {
    return (
        <Routes>
            {/* Public Route */}
            <Route path="/" element={<LandingPage />} />
            <Route element={<PublicRoute />}>
                <Route path="/login" element={<LoginSocial />} />
                <Route path="/login-apple" element={<LoginApple />} />
                <Route path="/login-email" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/register" element={<Register />} />
                <Route path="/signup" element={<SignUp />} />
            </Route>
            <Route path="/verify-otp" element={<VerifyOtp />} />

            <Route path="/congratulation" element={<Congratulation />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/explore-quikwise" element={<ExploreQuikwise />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/eula" element={<EULA />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/legal-disclosure" element={<LegalDisclosure />} />
            <Route path="/about-us" element={<AboutUs />} />


            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
                <Route element={<DashboardLayout />}>
                    <Route path="/chat" element={<NewChat />} />
                    <Route path="/new-chat" element={<NewChat />} />
                    <Route path="/chat/:id" element={<Chat />} />
                </Route>
                <Route path="/upgrade-plan" element={<UpgradePlan />} />
                <Route path="/manage-your-plan" element={<ManagePlan />} />
                <Route path="/order-summary" element={<OrderSummary />} />
                <Route path="/payment-history" element={<PaymentHistory />} />
                <Route path="/tran/:status" element={<Transaction />} />
                <Route path="/my-account" element={<MyAccount />} />
                <Route path="/quiz" element={<Quiz />} />
                <Route path="/quiz-result" element={<Result />} />
            </Route>

            {/* Catch-all for unmatched routes */}
            <Route path="*" element={<LandingPage />} />
        </Routes>
    );
};

export default AppRoutes;
